import clientAxios from "../config";

const validCode = async (token, data) => clientAxios.put(`/api/income-code-assign`, data, {
    headers: {
        Authorization: `Bearer ${token}`
    }
});

/**
 * Validación pública de un código (sin consumirlo). Aplica las mismas
 * reglas que el flujo de asignación/juego — incluyendo el guard de
 * "código privado solo para sesión activa" — pero no modifica BD.
 * Permite dar feedback real en el modal de recargar antes del juego.
 */
const checkCode = async (data) => clientAxios.post(`/api/income-code-check`, data);

const getAllIncomeCollection = async (token, params = {}) => clientAxios(`/api/income-collection`, {
    params,
    headers: {
        Authorization: `Bearer ${token}`
    }
});

const addIncomeCollection = async (token, data) => clientAxios.post(`/api/income-collection`, data, {
    headers: {
        Authorization: `Bearer ${token}`
    }
});

const getCodesByCollection = async (token, uuid, rowsPerPage, page) => clientAxios(`/api/income-codes-collection/${uuid}/${rowsPerPage}?page=${page}`, {
    headers: {
        Authorization: `Bearer ${token}`
    }
});

const exportIncomeCodeCollection = async (token, name, uuid) => clientAxios(`/api/export/income-collection/${name}/${uuid}`, {
    headers: {
        Authorization: `Bearer ${token}`
    },
    responseType: 'blob'
});

const getAllIncomeTypes = async (token) => clientAxios(`/api/income-type`, {
    headers: {
        Authorization: `Bearer ${token}`
    }
});

const transferMoves = async (token, data) => clientAxios.post(`/api/income-codes/transfer`, data, {
    headers: {
        Authorization: `Bearer ${token}`
    }
});

/**
 * Regalo de jugadas (admin → Jugador). Body: { user_uuid, moves }.
 * El backend crea una IncomeCollection nueva (prefix=GIFT) + N
 * IncomeCodes is_gift=1, status ASSIGNED, y suma N a user.moves.
 */
const giftMoves = async (token, data) => clientAxios.post(`/api/income-codes/gift`, data, {
    headers: {
        Authorization: `Bearer ${token}`,
    },
});

/**
 * Entrega de jugadas (admin → Distribuidor). Body:
 * { user_uuid, moves, gift_moves }.
 * El backend crea los IncomeCodes (entregadas + de regalo), suma el total a
 * user.moves y genera un invoice FENABOCOL por el valor de las jugadas
 * entregadas (las de regalo no se facturan).
 */
const deliverMovesToDistributor = async (token, data) => clientAxios.post(`/api/income-codes/deliver-distributor`, data, {
    headers: {
        Authorization: `Bearer ${token}`,
    },
});

/**
 * Entrega de jugadas (admin → cualquier usuario salvo Empresa) desde la
 * página Entregar jugadas. Body: { user_uuid, moves, gift_moves? }.
 * Si el destino es distribuidor el backend genera regalo + invoice; si es
 * jugador solo acredita las jugadas.
 */
const deliverMovesToUser = async (token, data) => clientAxios.post(`/api/income-codes/deliver`, data, {
    headers: {
        Authorization: `Bearer ${token}`,
    },
});

export {
    validCode,
    checkCode,
    getAllIncomeCollection,
    addIncomeCollection,
    getCodesByCollection,
    exportIncomeCodeCollection,
    getAllIncomeTypes,
    transferMoves,
    giftMoves,
    deliverMovesToDistributor,
    deliverMovesToUser,
}